export default __webpack_public_path__ + "static/media/avatar_1@3x.1137a6ac.png";